export enum IhaleAlicisi {
    alacakli_vekili = "alacakli_vekili",
    ucuncu_sahis = "ucuncu_sahis",
}

export enum IhaleAlicisiLabel {
    alacakli_vekili = "Alacaklı Vekili",
    ucuncu_sahis = "Üçüncü Şahıs",
}
